export default __webpack_public_path__ + "static/media/sakura2.6fd759fa.webp";